import { Skeleton } from "antd";

export const NotificationsListCardLoader = () => (
  <Skeleton
    active
    paragraph={{ rows: 2 }}
    style={{ padding: "var(--app-padding)" }}
  />
);
